// src/Skeleton.js

import React from "react";
import "./Skeleton.css";

export default function Skeleton({ width, height, style = {}, circle = false }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: circle ? "50%" : "8px",
        background: "linear-gradient(90deg, #ececec 25%, #f5f5f5 50%, #ececec 75%)",
        backgroundSize: "200% 100%",
        animation: "skeleton-loading 1.2s ease-in-out infinite",
        ...style,
      }}
      className="skeleton"
    />
  );
}
